export function getModuleEndpoints(template: ModuleTemplate, placeholder: boolean = true): Option<MethodDefinition>[]
{
    const pre: Option<MethodDefinition>[] = [
        ...(placeholder ? [{ value: null, text: '' }] : []),
        {
            value: { http: 'GET', name: 'schema', configurable: false, path: '/api/rest/{module}/schema' },
            text: $t('[[[GET: Schemat (definicja formularza)]]]')
        }
    ];
    const post: Option<MethodDefinition>[] = [
        {
            value: { http: 'POST', name: 'upload', configurable: false, path: '/api/rest/{module}/{id}/upload' },
            text: $t('[[[POST: Upload załączników]]]')
        }
    ];

    if (template == 'Settings')
    {
        return [
            ...pre,
            {
                value: { http: 'GET', name: 'form', configurable: false, path: '/api/rest/{module}/form' },
                text: $t('[[[GET: Pobranie danych]]]')
            },
            {
                value: { http: 'POST', name: 'form', configurable: false, path: '/api/rest/{module}/form' },
                text: $t('[[[POST: Zapisanie zmian]]]')
            },
            ...post
        ];
    }
    else
    {
        return [
            ...pre,
            {
                value: { http: 'GET', name: 'index', configurable: true, path: '/api/rest/{module}/index' },
                text: $t('[[[GET: Lista wpisów (sortowanie i stronicowanie)]]]')
            },
            {
                value: { http: 'POST', name: 'index', configurable: false, path: '/api/rest/{module}/index' },
                text: $t('[[[POST: Dowolne wyszukiwanie (Zapytanie EQL)]]]')
            },
            {
                value: { http: 'GET', name: 'fetch', configurable: true, path: '/api/rest/{module}/{id}' },
                text: $t('[[[GET: Pobranie wpisu]]]')
            },
            {
                value: { http: 'POST', name: 'create', configurable: false, path: '/api/rest/{module}' },
                text: $t('[[[POST: Utworzenie wpisu]]]')
            },
            {
                value: { http: 'PUT', name: 'update', configurable: false, path: '/api/rest/{module}/{id}' },
                text: $t('[[[PUT: Aktualizacja wpisu]]]')
            },
            {
                value: { http: 'DELETE', name: 'delete', configurable: false, path: '/api/rest/{module}/{id}' },
                text: $t('[[[DELETE: Usunięcie wpisu]]]')
            },
            ...post
        ];
    }
}
